import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationPrev } from "@breuni-ui/carousel";

class KombiModulCarouselNavigationPrev extends CarouselNavigationPrev {}
safeDefine(
  "reco-kombi-modul-carousel-navigation-prev",
  KombiModulCarouselNavigationPrev,
);
